<template>
  <div class="timeline-edit">
    <div class="header-back">
      <div class="header-item header-item-size" style="width: 30%">
        <a @click="$router.go(-1)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
            />
          </svg>
        </a>
      </div>
      <div
        class="text-center header-item"
        style="padding-top: 5px; width: 40%"
      ></div>
      <div class="header-item header-item-size" style="width: 30%">
        <div class="text-end" style="margin-right: 10px">
          <button
            type="button"
            style="width: 90px; border-radius: 30px !important"
            class="btn btn-kinkyer m-plus-medium"
            @click="sendTweet"
          >
            投稿する
          </button>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div>
              <table class="table table-borderless" style="margin: 0">
                <tbody>
                  <tr style="padding: 0">
                    <td
                      style="vertical-align: top; text-align: end; padding: 0"
                      width="50"
                    >
                      <listIcon :uid="user.uid" :is_icon="user.isIconUrl" />
                    </td>
                    <td style="word-break: break-word; padding: 0 10px 0 0">
                      <div class="highlight-wrapper">
                        <div
                          class="highlight-output"
                          ref="highlightOutput"
                          v-html="highlightedText"
                        ></div>

                        <textarea
                          ref="refReplayText"
                          class="highlight-input"
                          rows="5"
                          v-model="replayText"
                          @input="onInput"
                          @scroll="syncScroll"
                          @compositionstart="isComposing = true"
                          @compositionend="onCompositionEnd"
                          @keydown="onKeyDown"
                          placeholder="最近どう？"
                        ></textarea>
                        <ul
                          v-if="showSuggestions"
                          class="suggestions"
                          style="top: 130px"
                        >
                          <li
                            v-for="(suggestion, index) in filteredSuggestions"
                            :key="index"
                            :class="{ active: index === selectedIndex }"
                            @click="selectSuggestion(suggestion)"
                          >
                            #{{ suggestion }}
                          </li>
                        </ul>
                      </div>
                      <div class="text-end" style="font-size: 10px">
                        {{ replayText.length }}/300
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 画像 -->
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              style="display: none"
              @change="fileUpload"
            />
            <div
              v-if="img_urls.length > 0"
              style="
                height: 210px;
                display: flex;
                overflow-x: scroll;
                margin-bottom: 10px;
              "
            >
              <div
                v-for="(img_url, i) in img_urls"
                :key="i"
                style="float: left; flex-shrink: 0; width: auto; height: 210px"
              >
                <div
                  style="
                    position: relative;
                    float: right;
                    right: 30px;
                    top: 5px;
                    text-shadow:
                      1px 1px 2px #ffffff,
                      -1px 1px 2px #ffffff,
                      1px -1px 2px #ffffff,
                      -1px -1px 2px #ffffff,
                      1px 0px 2px #ffffff,
                      0px 1px 2px #ffffff,
                      -1px 0px 2px #ffffff,
                      0px -1px 2px #ffffff;
                  "
                >
                  <span
                    class="material-symbols-rounded"
                    style="color: red"
                    @click="removeImgs(i)"
                  >
                    close
                  </span>
                </div>
                <img
                  style="
                    width: auto;
                    height: 200px;
                    margin: 5px 5px 5px 0;
                    border-radius: 8px;
                    border: solid 1px #eee;
                  "
                  :src="img_url"
                />
              </div>
            </div>
            <div v-if="img_urls.length != 0">
              <div class="form-check" style="padding-bottom: 6px">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  style="margin-top: 7px"
                  v-bind:checked="isSensitive"
                  v-on:change="isSensitive = !isSensitive"
                />
                <label
                  class="form-check-label"
                  style="color: #888; font-size: 12px"
                >
                  アップロードする画像をセンシティブ設定にする,
                </label>
              </div>
            </div>
            <!-- 動画 -->
            <input
              id="video-upload"
              type="file"
              accept="video/*"
              style="display: none"
              @change="fileVideoUpload"
            />
            <div v-if="uploadVideoURL" style="padding: 5px 0">
              <video controls autoplay :src="uploadVideoURL" width="100%" />
              <div class="text-center" style="padding: 5px; font-size: 13px">
                <a @click="resetVideo">動画を削除する</a>
              </div>
            </div>
            <!-- メンション -->
            <div v-if="choiceUsers.length != 0">
              <div
                v-for="(user, i) in choiceUsers"
                :key="i"
                class=""
                style="
                  display: inline-flex;
                  color: #784ba0;
                  font-size: 14px;
                  font-weight: 600;
                  position: relative;
                  padding: 0 5px;
                "
              >
                @{{ user.name }}
              </div>
            </div>
            <!-- グループチャット -->
            <div
              v-if="roomSelected != 0"
              style="color: #784ba0; padding-top: 3px"
            >
              <div style="font-size: 11px">グループチャット連携：</div>
              <div style="font-size: 16px; font-weight: 600">
                {{ groupChat }}
              </div>
            </div>
            <!-- 期限 -->
            <div>
              <div class="note-timer" v-if="noteTimer == 12">
                翌日の12時に投稿を削除
              </div>
              <div class="note-timer" v-else-if="noteTimer == 24">
                翌日の24時に投稿を削除
              </div>
            </div>
            <hr />
            <div style="height: 30px; width: 100%; display: inline-flex">
              <div style="min-width: 35px">
                <label for="file-upload">
                  <div style="width: 30px; height: 30px; padding: 2.5px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="25px"
                      viewBox="0 -960 960 960"
                      width="25px"
                      fill="#784ba0"
                    >
                      <path
                        d="M480-480ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280q17 0 28.5 11.5T520-800q0 17-11.5 28.5T480-760H200v560h560v-280q0-17 11.5-28.5T800-520q17 0 28.5 11.5T840-480v280q0 33-23.5 56.5T760-120H200Zm40-160h480L570-480 450-320l-90-120-120 160Zm440-400h-40q-17 0-28.5-11.5T600-720q0-17 11.5-28.5T640-760h40v-40q0-17 11.5-28.5T720-840q17 0 28.5 11.5T760-800v40h40q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680h-40v40q0 17-11.5 28.5T720-600q-17 0-28.5-11.5T680-640v-40Z"
                      />
                    </svg>
                  </div>
                </label>
              </div>
              <div style="min-width: 35px">
                <label for="video-upload">
                  <div style="width: 30px; height: 30px; padding: 2.5px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="25px"
                      viewBox="0 -960 960 960"
                      width="25px"
                      fill="#784ba0"
                    >
                      <path
                        d="M360-440v80q0 17 11.5 28.5T400-320q17 0 28.5-11.5T440-360v-80h80q17 0 28.5-11.5T560-480q0-17-11.5-28.5T520-520h-80v-80q0-17-11.5-28.5T400-640q-17 0-28.5 11.5T360-600v80h-80q-17 0-28.5 11.5T240-480q0 17 11.5 28.5T280-440h80ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l126-126q10-10 22-5t12 19v344q0 14-12 19t-22-5L720-420v180q0 33-23.5 56.5T640-160H160Zm0-80h480v-480H160v480Zm0 0v-480 480Z"
                      />
                    </svg>
                  </div>
                </label>
              </div>
              <div style="min-width: 35px">
                <div
                  style="width: 30px; height: 30px; padding: 2.5px"
                  @click="insertHashTag"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="25px"
                    viewBox="0 -960 960 960"
                    width="25px"
                    fill="#784ba0"
                  >
                    <path
                      d="m360-320-33 131q-3 13-13 21t-24 8q-19 0-31-15t-7-33l28-112H171q-20 0-32-15.5t-7-34.5q3-14 14-22t25-8h129l40-160H231q-20 0-32-15.5t-7-34.5q3-14 14-22t25-8h129l33-131q3-13 13-21t24-8q19 0 31 15t7 33l-28 112h160l33-131q3-13 13-21t24-8q19 0 31 15t7 33l-28 112h109q20 0 32 15.5t7 34.5q-3 14-14 22t-25 8H660l-40 160h109q20 0 32 15.5t7 34.5q-3 14-14 22t-25 8H600l-33 131q-3 13-13 21t-24 8q-19 0-31-15t-7-33l28-112H360Zm20-80h160l40-160H420l-40 160Z"
                    />
                  </svg>
                </div>
              </div>
              <div style="min-width: 35px">
                <div
                  style="width: 30px; height: 30px; padding: 2.5px"
                  @click="
                    ((myBottomSheet = !myBottomSheet),
                    (sheetTag = false),
                    (sheetMention = true),
                    (resultUsers = []),
                    (searchWord = ''),
                    (sheetGroupChat = false),
                    (sheetTime = false))
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="25px"
                    viewBox="0 -960 960 960"
                    width="25px"
                    fill="#784ba0"
                  >
                    <path
                      d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480v58q0 59-40.5 100.5T740-280q-35 0-66-15t-52-43q-29 29-65.5 43.5T480-280q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480v58q0 26 17 44t43 18q26 0 43-18t17-44v-58q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93h160q17 0 28.5 11.5T680-120q0 17-11.5 28.5T640-80H480Zm0-280q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"
                    />
                  </svg>
                </div>
              </div>
              <div style="min-width: 35px">
                <div
                  style="width: 30px; height: 30px; padding: 2.5px"
                  @click="
                    ((myBottomSheet = !myBottomSheet),
                    (sheetTag = false),
                    (sheetMention = false),
                    (sheetGroupChat = false),
                    (sheetTime = true))
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="25px"
                    viewBox="0 -960 960 960"
                    width="25px"
                    fill="#784ba0"
                  >
                    <path
                      d="M520-456v-144q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600v159q0 8 3 15.5t9 13.5l112 112q11 11 28 11t28-11q11-11 11-28t-11-28L520-456ZM480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-800q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Zm0-360ZM82-668q-11-11-11-28t11-28l114-114q11-11 28-11t28 11q11 11 11 28t-11 28L138-668q-11 11-28 11t-28-11Zm796 0q-11 11-28 11t-28-11L708-782q-11-11-11-28t11-28q11-11 28-11t28 11l114 114q11 11 11 28t-11 28ZM480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160Z"
                    />
                  </svg>
                </div>
              </div>
              <div style="padding: 0 0 15px 10px; width: 100%">
                <select
                  style="
                    border: 0;
                    width: 100%;
                    font-size: 11px;
                    padding: 5px 15px;
                    border-radius: 20px;
                    color: #fff;
                    -webkit-appearance: none;
                    appearance: none;
                    background-image: url(./../../images/circle-arrow-down-solid.svg);
                    background-repeat: no-repeat;
                    background-size: 14px auto;
                    background-color: #784ba0;
                    background-position: right 12px center;
                  "
                  v-model="selected"
                >
                  <option value="all">{{ selectedRangeName }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
  <div
    v-show="isEdit"
    style="
      position: fixed;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: rgb(0 0 0 / 50%);
      margin: 0 auto;
      padding-top: 200px;
      text-align: center;
      z-index: 999;
    "
  >
    <div style="position: absolute; z-index: 9999; width: 100%">
      <VueSpinnerBars size="50" color="#fff" />
    </div>
  </div>
  <v-bottom-sheet v-model="myBottomSheet">
    <div class="container" style="min-height: 100%">
      <div class="row justify-content-center" style="min-height: 100%">
        <div class="col-md-8" style="padding: 0; min-height: 100%">
          <v-sheet height="500px" style="border-radius: 15px 15px 0 0">
            <div style="padding: 0px" class="text-center">
              <span
                class="material-symbols-rounded"
                style="color: #ccc; font-size: 40px"
                @click="myBottomSheet = !myBottomSheet"
              >
                remove
              </span>
            </div>
            <!-- ---------- メンション選択 ---------- -->
            <div style="height: 100%; padding: 0 15px" v-if="sheetMention">
              <div style="padding-bottom: 5px">メンション選択</div>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="searchWord"
                  placeholder="名前を検索"
                  @keydown.enter="searchMention"
                />
              </div>
              <div
                v-if="choiceUsers.length != 0"
                style="padding: 10px; overflow-y: scroll"
              >
                <div style="font-size: 12px">選択済みのメンション先</div>
                <div
                  v-for="(cuser, i) in choiceUsers"
                  :key="i"
                  :class="
                    choiceUsers.includes(cuser)
                      ? 'item-mention-selected'
                      : 'item-mention'
                  "
                  @click="setChoiceUsers(cuser)"
                >
                  <listIcon :uid="cuser.uid" :is_icon="cuser.isIconUrl" />
                  <div style="padding-top: 8px; padding-left: 5px">
                    @{{ cuser.name }}
                  </div>
                </div>
              </div>
              <div
                v-if="resultUsers.length != 0"
                style="padding: 10px; overflow-y: scroll"
              >
                <div style="font-size: 12px">検索結果</div>
                <div
                  v-for="(user, i) in resultUsers"
                  :key="i"
                  :class="
                    choiceUsers.includes(user)
                      ? 'item-mention-selected'
                      : 'item-mention'
                  "
                  @click="setChoiceUsers(user)"
                >
                  <listIcon :uid="user.uid" :is_icon="user.isIconUrl" />
                  <div style="padding-top: 8px; padding-left: 5px">
                    @{{ user.name }}
                  </div>
                </div>
              </div>
            </div>
            <!-- ---------- グループチャット ---------- -->
            <div
              style="height: 100%; padding: 0 15px"
              v-else-if="sheetGroupChat"
            >
              <div style="padding-bottom: 10px">グループチャット連携</div>
              <div>
                <select
                  style="
                    border: solid 1px #ccc;
                    width: 100%;
                    font-size: 13px;
                    padding: 5px;
                    border-radius: 6px;
                    -webkit-appearance: auto;
                    appearance: auto;
                    background-position: right 12px center;
                  "
                  v-model="roomSelected"
                  @change="groupChatChange"
                >
                  <option value="0">-</option>
                  <option
                    v-for="(room, i) in rooms"
                    :key="i"
                    :value="room.roomId"
                  >
                    {{ room.message }}
                  </option>
                </select>
                <div class="text-center" style="padding-top: 20px">
                  <a
                    @click="((roomSelected = 0), closeSheet)"
                    style="
                      font-size: 14px;
                      color: #784ba0;
                      text-decoration: underline;
                    "
                    >グループチャット連携を解除</a
                  >
                </div>
              </div>
            </div>
            <!-- ---------- インスタント設定 ---------- -->
            <div style="height: 100%; padding: 0 15px" v-else-if="sheetTime">
              <div style="padding-bottom: 5px">インスタント設定</div>
              <div
                style="
                  padding-bottom: 15px;
                  font-size: 12px;
                  padding: 8px;
                  background-color: #efefef;
                "
              >
                投稿後に翌日の12時もしくは24時に投稿を削除します。
              </div>
              <div class="form-check" style="padding-top: 20px">
                <input
                  class="form-check-input"
                  type="radio"
                  value="12"
                  v-model="noteTimer"
                  @click="closeSheet"
                />
                <label class="form-check-label"> 翌日の12時に投稿を削除 </label>
              </div>
              <div class="form-check" style="padding-top: 10px">
                <input
                  class="form-check-input"
                  type="radio"
                  value="24"
                  v-model="noteTimer"
                  @click="closeSheet"
                />
                <label class="form-check-label"> 翌日の24時に投稿を削除 </label>
              </div>
              <div class="text-center" style="padding-top: 20px">
                <a
                  @click="((noteTimer = 0), closeSheet)"
                  style="
                    font-size: 14px;
                    color: #784ba0;
                    text-decoration: underline;
                  "
                  >インスタンス設定を解除</a
                >
              </div>
            </div>
          </v-sheet>
        </div>
      </div>
    </div>
  </v-bottom-sheet>
</template>

<script>
import listIcon from "@/components/timeline/listIconView.vue";
import { db, storage } from "../../plugins/firebase";
import {
  doc,
  collection,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  arrayUnion,
  setDoc,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import {
  ref as storageRef,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { store } from "../../plugins/store";
import { setInformation } from "../../plugins/push";

import "@vojtechlanka/vue-simple-suggest/style.css";
import imageCompression from "browser-image-compression";

export default {
  data() {
    return {
      isEdit: false,
      uid: "",
      user: {},
      replayText: "",
      field: null,
      selectTags: [],
      valueCurrent: "",
      selectedCurrent: null,
      autocompleteItems: [],
      selected: "all",
      roomSelected: "0",
      files: [],
      img_urls: [],
      isUploadError: false,
      rooms: [],
      isSensitive: false,
      myBottomSheet: false,
      sheetTag: false,
      sheetMention: false,
      sheetGroupChat: false,
      sheetTime: false,
      noteTimer: 0,
      groupChat: "",
      searchWord: "",
      searchUsers: [], //検索対象（初期化の時にfirestoreから呼び出し
      resultUsers: [], //モーダル内で表示する検索結果
      choiceUsers: [], //メンションとして選択されたユーザたち
      fileVideo: null,
      uploadVideoURL: "",
      selectedRange: "all",
      selectedRangeName: "全員に公開",

      allSuggestions: [],
      filteredSuggestions: [],
      showSuggestions: false,
      selectedIndex: 0,
      hashtagQuery: "",

      isComposing: false, // IME中の判定
      composingText: "",
      unsubscribe: null,
    };
  },
  async created() {
    this.selectedRange = this.$route.query.range;

    if (this.selectedRange == "all") {
      this.selectedRangeName = "全員に公開";
    } else if (this.selectedRange == "follower") {
      this.selectedRangeName = "フォロワーに公開";
    } else if (this.selectedRange == "group") {
      this.selectedRangeName = "グループ公開";
    } else if (this.selectedRange == "like") {
      this.selectedRangeName = "いいね公開";
    } else if (this.selectedRange == "matching") {
      this.selectedRangeName = "マッチング公開";
    } else {
      this.selectedRangeName = "#" + this.selectedRange + "界隈";
    }

    this.user = store.user;
    this.uid = store.uid;

    const docTagRef = doc(db, "tags", "1");
    const docTagSnap = await getDoc(docTagRef);
    this.autocompleteItems = docTagSnap.data().tagList;
    this.allSuggestions = docTagSnap.data().tagList;

    const docUserListRef = doc(db, "user_list", "1");
    const docUserListSnap = await getDoc(docUserListRef);
    this.searchUsers = docUserListSnap.data().list;

    const docRoomRef = doc(db, "users", this.uid);
    const subcollectionRef = collection(docRoomRef, "groupChats");
    const subcollectionSnapshot = await getDocs(subcollectionRef);

    this.rooms = subcollectionSnapshot.docs.map((doc) => doc.data());
  },
  components: {
    listIcon,
  },
  methods: {
    /**
     * 投稿登録
     * @classdesc 新しい投稿を追加する
     * @classdesc 投稿文が空の場合はアラート
     * @classdesc 下記コレクションに追加
     * @classdesc users/$uid/notes
     * @classdesc notes/$noteId
     * @classdesc 2秒待機後にhomeに戻る
     */
    async sendTweet() {
      if (this.replayText == "") {
        this.$toast.show("投稿内容を入力してください", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      } else if (this.replayText.length > 300) {
        this.$toast.show("300文字以内にしてください", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      }
      this.isEdit = true;

      var noteId = "";

      const docRef = await addDoc(
        collection(db, `users/${this.user.uid}/notes`),
        {
          uid: this.user.uid,
        },
      );
      noteId = docRef.id;

      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = ("00" + (now.getMonth() + 1)).slice(-2);
      const dd = ("00" + now.getDate()).slice(-2);

      this.selectTags = (
        this.replayText.match(
          /#([\wぁ-んァ-ン一-龥ーａ-ｚＡ-Ｚ０-９々〆〤]+)/g,
        ) || []
      ).map((tag) => tag.replace(/^#/, ""));
      var tagView = "";
      const docTags = doc(db, "tags", "1");
      for (const e of this.selectTags) {
        tagView += `#${e} `;
        await updateDoc(docTags, {
          tagList: arrayUnion(e),
        });
      }

      var lineList = [noteId];

      await setDoc(doc(db, "users", this.user.uid, "notes", noteId), {
        noteId: noteId,
        uid: this.user.uid,
        userName: this.user.name,
        isIconUrl: this.user.isIconUrl,
        detail: this.replayText,
        likeUID: [],
        tags: this.selectTags,
        tagView: tagView,
        roomId: this.roomSelected,
        createdAt: new Date(),
        createdAtView: `${yyyy}年${mm}月${dd}日`,
        isReply: false,
        replyCount: 0,
        lineHistory: lineList,
        mentions: this.choiceUsers,
        limit: this.noteTimer,
        range: this.selectedRange,
        isSensitiveImageByTweet: this.isSensitive,
        noteIndex: 1,
        isRemove: false,
        isProfileShare: false,
      });

      await setDoc(doc(db, "notes", noteId), {
        noteId: noteId,
        uid: this.user.uid,
        isIconUrl: this.user.isIconUrl,
        userName: this.user.name,
        detail: this.replayText,
        likeUID: [],
        tags: this.selectTags,
        tagView: tagView,
        roomId: this.roomSelected,
        createdAt: new Date(),
        createdAtView: `${yyyy}年${mm}月${dd}日`,
        isReply: false,
        replyCount: 0,
        lineHistory: lineList,
        mentions: this.choiceUsers,
        limit: this.noteTimer,
        range: this.selectedRange,
        isSensitiveImageByTweet: this.isSensitive,
        noteIndex: 1,
        isRemove: false,
        isProfileShare: false,
      });

      try {
        //image
        const docUpdateImageRef = doc(db, "notes", noteId);
        const docUpdateUserImageRef = doc(
          db,
          "users",
          this.user.uid,
          "notes",
          noteId,
        );

        for (var i in this.files) {
          var imageId = "";
          const docImageRef = await addDoc(
            collection(db, `notes/${noteId}/images`),
            {
              uid: this.user.uid,
            },
          );
          imageId = docImageRef.id;

          const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 800,
            useWebWorker: true,
          };
          const compressedFile = await imageCompression(this.files[i], options);
          const fileRef = storageRef(
            storage,
            `notes/${imageId}/${compressedFile.name}`,
          );
          await uploadBytes(fileRef, compressedFile);

          await updateDoc(docUpdateImageRef, {
            url: arrayUnion(`notes/${imageId}/${compressedFile.name}`),
          });
          await updateDoc(docUpdateUserImageRef, {
            url: arrayUnion(`notes/${imageId}/${compressedFile.name}`),
          });
        }

        //video
        if (this.fileVideo != null) {
          var videoId = "";
          const docImageRef = await addDoc(
            collection(db, `notes/${noteId}/videos`),
            {
              uid: this.user.uid,
            },
          );
          videoId = docImageRef.id;

          const fileName = `${Date.now()}_${this.fileVideo.name}`;

          await updateDoc(docUpdateImageRef, {
            videoUrl: `notes/videos/${videoId}/${fileName}`,
          });
          await updateDoc(docUpdateUserImageRef, {
            videoUrl: `notes/videos/${videoId}/${fileName}`,
          });

          const fileRef = storageRef(
            storage,
            `notes/videos/${videoId}/${fileName}`,
          );
          const uploadTask = uploadBytesResumable(fileRef, this.fileVideo);

          uploadTask.on(
            "state_changed",
            null,
            (uploadError) => {
              console.error = `アップロードエラー: ${uploadError.message}`;
            },
            async () => {
              const uploadURL = await getDownloadURL(uploadTask.snapshot.ref);

              console.log("アップロード成功: ", uploadURL);
            },
          );
        }
      } catch (error) {
        console.error("Error uploading file:", error);

        this.isEdit = false;
        this.$toast.show("投稿時にエラーが発生しました", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      }

      // todo::
      /**
       * 通知
       * メンションがある場合はメンション先に通知する
       *
       * タグ
       * 新しく入力してる場合は追加
       */
      const docInforRef = doc(db, "notes", noteId);
      const docSnap = await getDoc(docInforRef);

      const infoUser = {
        uid: this.user.uid,
        icon_url: store.userIconUrl,
        name: this.user.name,
      };

      this.choiceUsers.forEach((element) => {
        setInformation(
          element.uid,
          "さんからメンションされました",
          "note_mention",
          "/timeline/detail",
          docSnap.data(),
          element.token,
          false,
          infoUser,
        );
      });

      this.$toast.show("投稿完了しました", {
        position: "bottom",
        duration: 2000,
      });
      await this.delay(2000);
      this.isEdit = false;
      this.$router.push("/home");
    },
    removeTag(i) {
      this.selectTags.splice(i, 1);
    },
    setTags() {
      if (this.valueCurrent == "") {
        return;
      }

      if (!this.selectTags.includes(this.valueCurrent)) {
        this.selectTags.push(this.valueCurrent);
        this.valueCurrent = "";
        this.selectedCurrent = null;
        this.field = null;
      }
    },
    fileUpload(event) {
      if (this.img_urls.length >= 4) {
        this.isUploadError = true;
      } else {
        const file = event.target.files[0];

        this.img_urls.push(URL.createObjectURL(file));
        this.files.push(file);
      }
    },
    removeImgs(i) {
      this.isUploadError = false;
      this.img_urls.splice(i, 1);
      this.files.splice(i, 1);
      if (this.img_urls.length == 0) {
        this.isSensitive = false;
      }
    },
    async groupChatChange(event) {
      this.groupChat = event.target.options[event.target.selectedIndex].text;
      await this.delay(500);
      this.myBottomSheet = false;
    },
    searchMention() {
      if (this.searchWord == "") {
        return;
      }

      this.usersCollection = collection(db, `users`);
      const baseQuery = query(
        this.usersCollection,
        where("name", "==", this.searchWord),
        where("uid", "!=", this.user.uid),
      );
      this.usersQuery = query(baseQuery);

      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = onSnapshot(this.usersQuery, (snapshot) => {
        const docs = snapshot.docs
          .map((doc) => {
            const data = doc.data();

            if ((data.blockedUID || []).includes(this.user.uid)) {
              return null;
            }
            const index = this.choiceUsers.findIndex((u) => u.uid === data.uid);
            if (index !== -1) {
              return null;
            }

            return data;
          })
          .filter((item) => item !== null);

        this.resultUsers = docs;
      });
    },
    setChoiceUsers(user) {
      const index = this.choiceUsers.findIndex((u) => u.uid === user.uid);

      if (index !== -1) {
        const index = this.choiceUsers.indexOf(user);
        if (index !== -1) {
          this.choiceUsers.splice(index, 1); // 配列から削除
        }
        this.resultUsers.push(user);
      } else {
        this.choiceUsers.push(user);
        const resultIndex = this.resultUsers.findIndex(
          (u) => u.uid === user.uid,
        );
        if (resultIndex !== -1) {
          this.resultUsers.splice(resultIndex, 1);
        }
      }
    },
    fileVideoUpload(event) {
      const selectedFile = event.target.files[0];

      if (!selectedFile) {
        return;
      }

      // 動画ファイルか確認
      if (selectedFile.type.startsWith("video/")) {
        this.fileVideo = selectedFile;
        this.uploadVideoURL = URL.createObjectURL(selectedFile);

        // 一時的なURL生成
        const tempURL = URL.createObjectURL(selectedFile);
        // 一時的なvideo要素を作成してメタデータを読み込む
        const videoElement = document.createElement("video");
        videoElement.preload = "metadata";
        videoElement.src = tempURL;

        videoElement.onloadedmetadata = () => {
          // 動画の長さ（秒）をチェック：3分（180秒）以内か
          if (videoElement.duration <= 180) {
            this.fileVideo = selectedFile;
            this.uploadVideoURL = tempURL; // プレビュー用に保持（コンポーネントの破棄時に revoke するなどの管理を検討）
          } else {
            this.fileVideo = null;
            this.uploadVideoURL = "";
            // 不要なオブジェクトURLは解放
            URL.revokeObjectURL(tempURL);

            this.$toast.show("動画の長さは3分以内である必要があります", {
              type: "error",
              position: "bottom",
              duration: 2000,
            });
          }
        };

        videoElement.onerror = () => {
          this.fileVideo = null;
          this.uploadVideoURL = "";
          URL.revokeObjectURL(tempURL);
        };
      }
    },
    resetVideo() {
      this.fileVideo = null;
      this.uploadVideoURL = "";
    },
    async closeSheet() {
      await this.delay(500);
      this.myBottomSheet = false;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    syncScroll() {
      if (this.$refs.refReplayText && this.$refs.highlightOutput) {
        this.$refs.highlightOutput.scrollTop =
          this.$refs.refReplayText.scrollTop;
      }
    },
    onInput() {
      const textarea = this.$refs.refReplayText;
      if (!textarea) {
        console.warn("refReplayText がまだマウントされていません。");
        this.showSuggestions = false;
        return;
      }

      if (this.isComposing) {
        // IME入力中は textarea.value を直接取得
        this.composingText = textarea.value;
      } else {
        this.replayText = textarea.value;
        this.composingText = "";
        this.syncScroll();
      }

      const cursorPos = textarea.selectionStart;
      const beforeCursor = this.replayText.slice(0, cursorPos);
      const match = beforeCursor.match(
        /#([\wぁ-んァ-ン一-龥ーａ-ｚＡ-Ｚ０-９々〆〤]*)$/,
      );

      if (match) {
        this.hashtagQuery = match[1];
        this.allSuggestions.push(this.hashtagQuery);
        this.allSuggestions = [...new Set(this.allSuggestions)];
        this.filteredSuggestions = this.allSuggestions.filter((tag) =>
          `#${tag}`
            .toLowerCase()
            .includes(`#${this.hashtagQuery.toLowerCase()}`),
        );
        this.showSuggestions = this.filteredSuggestions.length > 0;
        this.selectedIndex = 0;
      } else {
        this.showSuggestions = false;
      }
    },
    getCursorLine(textarea) {
      const textBeforeCursor = textarea.value.slice(0, textarea.selectionStart);
      return (textBeforeCursor.match(/\n/g) || []).length;
    },
    selectSuggestion(suggestion) {
      const fullTag = `#${suggestion} `;
      const textarea = this.$refs.refReplayText;
      const cursorPos = textarea.selectionStart;

      const beforeCursor = this.replayText.slice(0, cursorPos);
      const afterCursor = this.replayText.slice(cursorPos);

      // ハッシュタグを挿入
      const newBefore = beforeCursor.replace(
        /#([\wぁ-んァ-ン一-龥ーａ-ｚＡ-Ｚ０-９々〆〤]*)$/,
        fullTag,
      );
      this.replayText = newBefore + afterCursor;

      // 現在のスクロール位置を保存
      const savedScrollTop = textarea.scrollTop;

      const index = this.replayText.indexOf(fullTag);

      if (index !== -1) {
        this.$nextTick(() => {
          textarea.focus();
          textarea.setSelectionRange(
            index + fullTag.length,
            index + fullTag.length,
          );

          // スクロール位置を元に戻す
          textarea.scrollTop = savedScrollTop;
        });
      }

      this.showSuggestions = false;
    },
    onArrowDown() {
      if (this.selectedIndex < this.filteredSuggestions.length - 1) {
        this.selectedIndex++;
      }
    },
    onArrowUp() {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
      }
    },
    onCompositionEnd() {
      this.isComposing = false;

      // IME確定直後にinputイベント処理を呼ぶ
      this.$nextTick(() => {
        this.onInput(); // onInput() 内で match と suggestion をチェック
      });
    },
    onEnterIfNotComposing() {
      if (!this.isComposing) {
        this.onEnter();
      }
    },
    onEnter() {
      const suggestion = this.filteredSuggestions[this.selectedIndex];
      if (suggestion) {
        this.selectSuggestion(suggestion);
      }
    },
    onKeyDown(e) {
      const textarea = this.$refs.refReplayText;

      // 矢印キーで動いたらスクロールを同期
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
        this.$nextTick(() => {
          this.$refs.highlightOutput.scrollTop = textarea.scrollTop;
        });
      }
    },
    insertHashTag() {
      const textarea = this.$refs.refReplayText;
      if (!textarea) return;

      textarea.focus();

      const cursorPos = textarea.selectionStart;
      const before = this.replayText.slice(0, cursorPos);
      const after = this.replayText.slice(cursorPos);

      // すでに直前に # があれば追加しない
      if (before.endsWith("#")) return;

      const insertText = "#";
      this.replayText = before + insertText + after;

      this.$nextTick(() => {
        const newPos = cursorPos + insertText.length;
        textarea.setSelectionRange(newPos, newPos);
      });

      this.hashtagQuery = "";
      this.allSuggestions.push(this.hashtagQuery);
      this.allSuggestions = [...new Set(this.allSuggestions)];
      this.filteredSuggestions = this.allSuggestions.filter((tag) =>
        `#${tag}`.toLowerCase().includes(`#${this.hashtagQuery.toLowerCase()}`),
      );
      this.showSuggestions = this.filteredSuggestions.length > 0;
      this.selectedIndex = 0;
    },
  },
  beforeUnmount() {
    if (this.videoURL) {
      URL.revokeObjectURL(this.uploadVideoURL); // メモリリーク防止
    }
  },
  computed: {
    highlightedText() {
      const text = this.isComposing ? this.composingText : this.replayText;

      const escaped = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      const withHashtags = escaped.replace(
        /#([\wぁ-んァ-ン一-龥ーａ-ｚＡ-Ｚ０-９々〆〤]+)(?=\s|$)/g,
        '<span style="color: #784ba0;">#$1</span>',
      );

      // ✅ 改行を <br> に変換しつつ、高さを維持するためにゼロ幅文字を追加
      return withHashtags.replace(/\n/g, "<br><wbr>");
    },
  },
};
</script>

<style scoped>
a {
  color: #784ba0 !important;
  text-decoration: underline !important;
}
a:focus {
  color: #784ba0 !important;
  text-decoration: underline !important;
}
.timeline-edit {
  animation: fadeIn 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  min-height: 100%;
  background-color: #fff;
}

.page {
  padding-top: 5px;
}

.btn-kinkyer {
  border: solid 1px #784ba0;
  background-color: #784ba0;
  color: #fff;
  width: 100%;
  border-radius: 30px;
  font-size: 14px;
  font-weight: bold;
}

.btn-kinkyer:hover {
  background-color: #633988;
  color: #fff;
  outline: none;
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0);
}

.btn-kinkyer:active {
  background-color: #633988;
  color: #fff;
  outline: none;
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0);
}

.btn-kinkyer:not(:disabled):not(.disab-outlineled):active,
.btn-kinkyer:not(:disabled):not(.disabled).active,
.show > .btn-l-outlineuna.dropdown-toggle {
  background-color: #633988;
  color: #fff;
  outline: none;
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0);
}

.btn:focus {
  outline: none;
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0);
}
.icon {
  color: #784ba0;
  font-size: 30px;
}
.header-item {
  float: left;
}
.header-item-size {
  padding-top: 14px;
  padding-left: 8px;
  padding-right: 8px;
}
.title {
  color: #784ba0;
  font-size: 30px;
}

.header-back {
  width: 100%;
  height: 60px;
  z-index: 99;
}
.note-timer {
  color: #784ba0;
  font-size: 12px;
  font-weight: 600;
  padding-top: 5px;
}
.item-mention {
  display: inline-flex;
  color: #784ba0;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  padding: 5px;
  width: 100%;
  margin: 3px 0;
}
.item-mention-selected {
  display: inline-flex;
  color: #784ba0;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  padding: 5px;
  width: 100%;
  margin: 3px 0;
  background-color: #784ba03b;
  border-radius: 5px;
}
.suggestions {
  position: absolute;
  top: 80px;
  left: 0;
  border: 1px solid #ccc;
  background: white;
  list-style: none;
  padding: 0;
  margin: 4px 0 0 0;
  width: 200px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 9999;
  font-size: 12px;
}
.suggestions li {
  padding: 6px 10px;
  cursor: pointer;
}
.suggestions li.active {
  background-color: #f0f0f0;
}
.highlight-wrapper {
  position: relative;
  width: 100%;
  height: 120px; /* ← 5行分で固定 */
}

.highlight-output,
.highlight-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px; /* ← 同じく固定 */
  padding: 8px;
  font-size: 16px;
  line-height: 1.5;
  font-family: inherit;
  box-sizing: border-box;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.highlight-output {
  color: black;
  pointer-events: none;
  z-index: 0;
}

.highlight-input {
  background-color: transparent;
  color: transparent;
  caret-color: black;
  border: 0;
  resize: none;
  z-index: 1;
}
.highlight-input:focus {
  box-shadow: 0 0 0 0 rgba(0, 123, 255, 0) !important;
  outline: none !important;
}
.highlight-input::selection {
  background-color: #784ba01a;
  color: transparent;
}
</style>
